export default "__VITE_ASSET__C9v49$$v__"